import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Service } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ServiceModule extends VuexModule {
    @Action
    [Service.getServiceList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/services/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Service.findPageService](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/services`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Service.saveService](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/services/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Service.deleteService](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/services/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}